import PropTypes from "prop-types";
import { useMemo } from "react";

const CardList = ({ data, CardListItem }) => {
  const cards = useMemo(() => {
    return data.map((itemProps, index) => (
      <CardListItem key={index} {...itemProps} />
    ));
  }, [data]);

  return (
    <div
      className="my-12 grid grid-cols-1 gap-7 px-5 sm:grid-cols-2 
      lg:grid-cols-3 xl:grid-cols-4"
    >
      {cards}
    </div>
  );
};

CardList.propTypes = {
  data: PropTypes.array,
  CardListItem: PropTypes.func,
};

export default CardList;
